import ReactDocxArchive from "./ReactDocxArchive";

export default ReactDocxArchive;
